import { render, staticRenderFns } from "./figure-card-cmp.vue?vue&type=template&id=2925cb46&scoped=true"
import script from "./figure-card-cmp.vue?vue&type=script&lang=js"
export * from "./figure-card-cmp.vue?vue&type=script&lang=js"
import style0 from "./figure-card-cmp.vue?vue&type=style&index=0&id=2925cb46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2925cb46",
  null
  
)

export default component.exports